import React from "react";

export const Header = (props) => {
  return (
    <header id="header" >
      <div className="intro">
        <div className="">
          <div className="container">
            <div className="row overlay">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1 className="text-center p-3 overlay">

                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p className="text-center p-3 overlay">{props.data ? props.data.paragraph : "Loading"}</p>


                <a
                  href="/apply"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Apply Now
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
